module.exports = __webpack_public_path__ + "static/media/dice_4.e4a3b753.svg";